type Gtag = (...args: unknown[]) => void;
type Clarity = ((...args: unknown[]) => void) & { q?: unknown[][] };
type AnalyticsEnv = { VITE_GA_MEASUREMENT_ID?: string; VITE_CLARITY_PROJECT_ID?: string };

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: Gtag;
    clarity?: Clarity;
  }
}

const env = (import.meta as ImportMeta & { env?: AnalyticsEnv }).env ?? {};
const gaMeasurementId = env.VITE_GA_MEASUREMENT_ID?.trim();
const clarityProjectId = env.VITE_CLARITY_PROJECT_ID?.trim();
export const analyticsConfigured = Boolean(gaMeasurementId || clarityProjectId);

function appendScript(id: string, src: string) {
  if (document.getElementById(id)) return;
  const script = document.createElement("script");
  script.id = id;
  script.async = true;
  script.src = src;
  document.getElementsByTagName("head")[0]?.appendChild(script);
}

export function initializeAnalytics() {
  if (localStorage.getItem("itr_analytics_consent") !== "granted") return;
  if (gaMeasurementId) {
    window.dataLayer ??= [];
    window.gtag ??= (...args: unknown[]) => window.dataLayer?.push(args);
    window.gtag("js", new Date());
    window.gtag("config", gaMeasurementId, { send_page_view: false });
    appendScript("google-analytics", `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(gaMeasurementId)}`);
  }

  if (clarityProjectId) {
    if (!window.clarity) {
      const clarity: Clarity = (...args: unknown[]) => {
        clarity.q ??= [];
        clarity.q.push(args);
      };
      window.clarity = clarity;
    }
    appendScript("microsoft-clarity", `https://www.clarity.ms/tag/${encodeURIComponent(clarityProjectId)}`);
  }
}

export function setAnalyticsConsent(granted: boolean) {
  localStorage.setItem("itr_analytics_consent", granted ? "granted" : "denied");
}

export function trackPageView(path: string) {
  const language = path === "/fa" || path.startsWith("/fa/") ? "fa" : "en";
  if (gaMeasurementId && window.gtag) {
    window.gtag("event", "page_view", {
      page_location: `${window.location.origin}${path}`,
      page_path: path,
      page_title: document.title,
      language,
    });
  }
  window.clarity?.("set", "language", language);
}
